import { SalesChannelCategoryGroupCreatePage } from "@/features/sales-channel-category-group/pages/SalesChannelCategoryGroupCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/sales-channel-category-group/create",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["sales_channel_category_groups.create"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesChannelCategoryGroupCreatePage,
});
